/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AtImageCachingEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('AT_IMAGE_CACHING_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class AtImageCachingEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AtImageCachingEnabledSettingParser.decode(input).map(res => new AtImageCachingEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return AtImageCachingEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AtImageCachingEnabledSettingParser.encode(data);
    }
    static schema() {
        return AtImageCachingEnabledSettingParser.schema();
    }
}
